import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'org_unit_name', label: 'Cost Centre' },
  { key: 'account_label', label: 'Account' },
  { key: 'type', label: 'Type' },
  { key: 'budget', label: 'Budget', align: 'right', type: 'money' },
  { key: 'committed', label: 'Committed', align: 'right', type: 'money' },
  { key: 'available', label: 'Available', align: 'right', type: 'money' },
];

export function CommittedBudgetReport() {
  return (
    <ReportView
      title="Committed Budget"
      description="Each budget line with its revised budget, committed (in-flight purchase requests/orders) and remaining available balance. Defaults to the budget covering today."
      endpoint="/reports/budgets/committed"
      columns={COLUMNS}
      defaultSort="account_label"
      xlsx
    />
  );
}
